const api = {
  appraiserOrderRequirements(customerNumber, surveyTypeCode) {
    return `/customers/${customerNumber}/survey-type/${surveyTypeCode}/appraiser-order-requirements`;
  }
};

export default api;
